import { keepPreviousData, Query, useQuery } from '@tanstack/react-query'
import { DurationInMilliseconds } from 'constants/General'
import { BatchStatus, FiatPayout } from 'pages/MassPayouts/types'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getMassFiatPayoutsRecords } from 'services/MasspayoutService'
import { WithPaginationApiResponse } from 'types/pagination'
import { QueryMetaType } from 'types/reactQuery'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET, withPaginationPaging } from 'utils/pagination'

export interface GetMassFiatRecordsProps {
  batchReference: string
  page?: number
  size?: number
  enabled?: boolean
}

export const useGetMassFiatPayoutsRecordsQuery = ({
  batchReference,
  size = API_PAGINATION_LIMIT,
  page = API_PAGINATION_OFFSET,
  enabled = true,
}: GetMassFiatRecordsProps) => {
  const meta: QueryMetaType = {
    errorAdditionalData: {
      batchReference,
    },
  }

  const getRefetchInterval = (query: Query): number | false | undefined => {
    const batchStatus = (query?.state?.data as FiatPayout)?.status
    return !batchStatus ||
      batchStatus === BatchStatus.CREATED ||
      batchStatus === BatchStatus.PROCESSING
      ? DurationInMilliseconds.THIRTY_SECONDS
      : false
  }

  return useQuery({
    queryKey: reactQueryKeys.massFiatPayoutsRecords({ batchReference, size, page }),
    queryFn: () => getMassFiatPayoutsRecords({ batchReference, size, page }),
    enabled: enabled,
    placeholderData: keepPreviousData,
    gcTime: DurationInMilliseconds.THIRTY_SECONDS,
    meta,
    refetchInterval: getRefetchInterval,
    refetchIntervalInBackground: true,
    select: (res: WithPaginationApiResponse<FiatPayout>) => {
      //  Transform the result to removing default Pageable pagination and adding Paging object
      const fiatBatchWithPagination = withPaginationPaging<FiatPayout>(res)
      return fiatBatchWithPagination
    },
  })
}
